var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-check",class:[_vm.disabled ? 'disabled' : '', _vm.size],on:{"click":function($event){_vm.check = !_vm.check}}},[_c('icon',{staticClass:"ui-check__icon",attrs:{"src":_vm.iconSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }